export default __webpack_public_path__ + "static/slider-gym-4206ef17407567a81bfa43015764ef3c.png";